export default __webpack_public_path__ + "static/media/newbie_project4.2f523cb9.jpg";